import type { useIntl } from 'react-intl';

type FormatMessage = ReturnType<typeof useIntl>['formatMessage'];

/**
 * The label shown for a table: its name exactly as provided, with no prefix or
 * numbering added. Only a table that has no name falls back to "Table N", N
 * being its 1-based position.
 */
export const getTableLabel = (
  name: string | null | undefined,
  tableNumber: number,
  formatMessage: FormatMessage
): string =>
  name && name.trim() !== ''
    ? name
    : formatMessage({ id: 'analysisDetail.tables.fallbackName' }, { number: tableNumber });
